import type { ReactNode } from 'react';

import styles from './Notice.module.css';

const ICONS = { info: 'ℹ', warn: '!', error: '!' } as const;

/**
 * 한 줄 안내.
 *
 * 오류일 때 `role="alert"`을 붙인다 — 화면을 못 보는 사용자에게도
 * 즉시 읽히게. 색만 바꾸면 그 정보가 전달되지 않는다.
 */
export function Notice({
  tone = 'info',
  children,
}: {
  tone?: 'info' | 'warn' | 'error';
  children: ReactNode;
}) {
  return (
    <div
      className={`${styles.notice} ${styles[tone]}`}
      {...(tone === 'error' ? { role: 'alert' as const } : {})}
    >
      <span className={styles.icon} aria-hidden="true">
        {ICONS[tone]}
      </span>
      <span>{children}</span>
    </div>
  );
}
